/** Defines a class for making ajax calls using the fetch api. **/
export class Ajax {
    //aResponse; 

    constructor() {
        this.aResponse;
    }

    /**
     * Performs a GET request.
     * @param {string} url - url path.
     */
    get(url, data) {
        return this.sendRequest('GET', url, '');
    }

    /**
     * Performs a DELETE request.
     * @param {string} url - url path.
     */
    delete(url) {
        return this.sendRequest('DELETE', url);
    }

    /**
     * Performs a POST request.
     * @param {string} url - url path.
     * @param {string} data - Form data.
     */
    post(url, data) {
        return this.sendRequest('POST', url, data);
    }

    /**
     * Performs a PUT request.
     * @param {string} url - url path.
     * @param {string} data - Form data.
     */
    put(url, data) {
        return this.sendRequest('PUT', url, data);
    }

    /**
     * Performs a request.
     * @param {string} method - GET,PUT,POST,DELETE,etc
     * @param {string} url - url path.
     * @param {string} data - Form data.
     */
    sendRequest(method, url, data) {
        const options = {
            method: method,
            credentials: 'include',
            headers: {
                'Accept': 'application/json'
            }
        };
        if (method == 'POST' || method == 'PUT') {
            options['body'] = data;
        }
        return fetch(url, options)
        .then(response => {
            let body = response.json();
            // Can't return with body as 2 value array as that will make body unaccessable as an object 
            // (instead will return as a promise if returned).  So just set it to the object attribute to be accessbile
            // in the next then call.
            this.aResponse = response;
            return body;
        })
        .then(body => {
            // Allows status codes like 404 for valid server responses to trigger the catch logic.
            if (body.code == 400 || !this.aResponse.ok) {
                // Setting this.aResponse from previous then call allows us to pass it in here.
                console.log('throwing error from 400 code in 200 response');
                this.throwResponseError(this.aResponse, 400, body);
            }
            return body;
        })
        .catch(error => {
            if (typeof error.responseBody === 'undefined') {
                error.responseBody = '';
            }
            throw error;
        });
    }

    /**
     * Triggers an error throw used in requests for exception handling of responses not automatcially error triggering by the fetch api *
     * (like 404).
     * @param {string} response - The fetch response object.
     * @param {body} code - Response code to set as the error status value.
     * @param {string} body - Json response body.
     */
    throwResponseError(response, code, body) {
        let err = new Error("HTTP status code: " + response.status);
        err.response = response;
        err.status = (typeof code !== 'undefined') ? code : response.status;
        if (typeof body !== 'undefined') {
            err.responseBody = body;
        } else {
            //err.responseBody = response.json();
            err.responseBody = '';
        }
        throw err;
    }
}
